module.exports = "<div class=\"card\"> \n  <div class=\"chart-container\">\n  <div class=\"skeleton-card\">\n\n    <div class=\"skeleton-bars\">\n      <div class=\"skeleton-bar\" style=\"height: 40%;\"></div>\n      <div class=\"skeleton-bar\" style=\"height: 60%;\"></div>\n      <div class=\"skeleton-bar\" style=\"height: 80%;\"></div>\n      <div class=\"skeleton-bar\" style=\"height: 40%;\"></div>\n      <div class=\"skeleton-bar\" style=\"height: 60%;\"></div>\n    </div>\n  </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-ghost-card-module/bar-chart-ghost-card/bar-chart-ghost-card.component.html
// module id = 1022
// module chunks = 6